import React from 'react';
import { bool, string } from 'prop-types';

import { imageUrl } from 'util/images';

const MenuItem = ({ title, image, selected }) => (
  <div className={`VideoPlaylist__item ${selected ? 'active' : ''}`}>
    <div className="VideoPlaylist__item-thumb">
      <img src={imageUrl(image, { width: 260 })} alt="" />
    </div>
    <div className="VideoPlaylist__item-title">{title}</div>
  </div>
);

MenuItem.propTypes = {
  title: string.isRequired,
  image: string.isRequired,
  selected: bool.isRequired
};

export default MenuItem;
